import React, { useEffect, useState } from "react";
import SelectVideos from "../../components/add/SelectVideos";
import TestSettings from "../../components/add/TestSettings";
import UploadTestContent from "../../components/add/UploadTestContent";
import RunTest from "../../components/add/RunTest";
import { VideoContext } from "../../context/video_context";

export default function AddTest() {
  const [step, setStep] = useState(0);
  const [page, setPage] = useState<any>();
  const videoContext = React.useContext(VideoContext);
  const getVideos = videoContext?.getVideos;

  function handlePageChangeUp() {
    let new_step: number = step + 1;
    setStep(new_step);
  }

  function handlePageChangeDown() {
    let new_step: number = step - 1;
    setStep(new_step);
  }

  function handlePageChange(new_step: number) {
    setStep(new_step);
  }

  function changePage() {
    switch (step) {
      case 0:
        setPage(
          <SelectVideos
            handlePageChangeUp={handlePageChangeUp}
            handlePageChangeDown={handlePageChangeDown}
            handlePageChange={handlePageChange}

          />,
        );
        console.log(step);
        break;
      case 1:
        setPage(
          <UploadTestContent
            handlePageChangeUp={handlePageChangeUp}
            handlePageChangeDown={handlePageChangeDown}
            handlePageChange={handlePageChange}

          />,
        );
        console.log(step);
        break;
      case 2:
        setPage(
          <TestSettings
            handlePageChangeUp={handlePageChangeUp}
            handlePageChangeDown={handlePageChangeDown}
            handlePageChange={handlePageChange}

          />,
        );
        console.log(step);
        break;
      case 3:
        setPage(
          <RunTest
            handlePageChangeUp={handlePageChangeUp}
            handlePageChangeDown={handlePageChangeDown}
            handlePageChange={handlePageChange}
          />,
        );
        console.log(step);
        break;
    }
  }

  useEffect(() => {
    changePage();
  }, [step]);

  // return (
  //   <TestSettings
  //     handlePageChangeUp={handlePageChangeUp}
  //     handlePageChangeDown={handlePageChangeDown}
  //   />
  // );
  return <div className="w-full">{page}</div>;
}
